(function () {

  'use strict';

  angular.module(moduleConfig.applicationModuleName)

    .controller('logoutCtrl', ['$scope', '$window', 'commonService',
      '$stateParams', 'uteModal', 'env', '$timeout', '$state', 'janrainService',
      '$rootScope',  function ($scope, $window, commonService, $stateParams,
                              uteModal, env, $timeout, $state, janrainService,
                              $rootScope) {
      var self = {};

      self.logout = function(){
        var forceRedirect = false;
        var isCFA = false;

        if ($rootScope.ruiMethods && $rootScope.ruiMethods.user && $rootScope.ruiMethods.user.is.agent()) {
          console.log('logged in as agent. logging out.');
          forceRedirect = false;
          isCFA = true;
        }

        if(isCFA){
          commonService.logOutUser(false, '', '', isCFA);
        }else {
          commonService.logOutUser(false, 'global.message.logOutMessage', 'login', isCFA);
        }

        if (forceRedirect) {
          var redirectToState = '';
          var redirectToURL = '';

          if (env.fidoHomePageUrl) {
            redirectToState = '';
            redirectToURL = env.fidoHomePageUrl;
          } else {
            redirectToState = 'login';
            redirectToURL = '';
          }

          console.log('redirectToState', redirectToState);
          console.log('redirectToURL', redirectToURL);

          if (redirectToURL) {
            $timeout(function () {
              console.log('redirecting to ', redirectToURL);
              $window.location.href = redirectToURL;
            }, 3000);
          } else {
            console.log('sending state to ', redirectToState);
            $state.go(redirectToState);
          }
        }

      };

      self.checkSSO = function(){
        console.log('is user logged in' + $rootScope.ruiMethods.user.is.loggedIn());
        if (janrainService.ssoFinished || $rootScope.ruiMethods.user.is.loggedIn()) {
          self.logout();
        } else {
          console.log('Waiting for JANRAIN-SSO.');

          $scope.$on('JANRAIN-SSO-FINISHED', function () {
            console.log('JANRAIN-SSO-FINISHED');

            self.logout();
          });
        }
      };

      self.init = function(){
        console.log('inside logout controller.');
        console.log('$stateParams.return', $stateParams.return);

        var cfaLoggingOut = $stateParams.cfaLoggingOut;

        if(cfaLoggingOut) {
          uteModal.open({
            templateUrl: 'modules/app/views/logout-modal.html',
            controller: /*@ngInject*/ ["$scope", "$modalInstance", function ($scope, $modalInstance) {
              $scope.cfaLoggingOut = cfaLoggingOut;
              $scope.ok = function () {
                $modalInstance.close();
              };
              $scope.cancel = function () {
                $modalInstance.dismiss('cancel');
              };
            }],
            ok: function () {
            },
            cancel: function () {
            },
            backdrop:'static'
          });
        }


        self.checkSSO();
      };

      self.init();
    }]);
})();
